import { h } from "preact";

import { classNames } from "../helpers";

import Logo from "../../static/images/logo.svg";
import IconClock from "../../static/images/icon_clock.svg";
import IconResidencyPermitChecker from "../../static/images/icon_residency_permit_checker.svg";
import IconEligibilityChecker from "../../static/images/icon_eligibility_checker.svg";
import Icon_choice_add from "../../static/images/icon_choice_add.svg";
import Icon_choice_link from "../../static/images/icon_choice_link.svg";
import Icon_choice_pdf from "../../static/images/icon_choice_pdf.svg";
import Icon_comparability_procedure from "../../static/images/icon_comparability_procedure.svg";
import Icon_diplomatic_mission_finder from "../../static/images/icon_diplomatic_mission_finder.svg";
import Icon_documents from "../../static/images/icon_documents.svg";
import Icon_early_bird from "../../static/images/icon_early_bird.svg";
import Icon_find_immigration_office from "../../static/images/icon_find_immigration_office.svg";
import Icon_health_insurance from "../../static/images/icon_health_insurance.svg";
import Icon_job_finder from "../../static/images/icon_job_finder.svg";
import Icon_handshake_big from "../../static/images/icon_handshake_big.svg";
import Icon_headset from "../../static/images/icon_headset.svg";
import Icon_projects_add from "../../static/images/icon_projects_add.svg";
import Icon_projects_pending from "../../static/images/icon_projects_pending.svg";
import Icon_projects_requested from "../../static/images/icon_projects_requested.svg";
import Icon_recognition_procedure from "../../static/images/icon_recognition_procedure.svg";
import Icon_registration_documents from "../../static/images/icon_registration_documents.svg";
import Icon_registration_office_finder from "../../static/images/icon_registration_office_finder.svg";
import Icon_registration from "../../static/images/icon_registration.svg";
import Icon_regulated_profession_check from "../../static/images/icon_regulated_profession_check.svg";
import Icon_residency_permit_application from "../../static/images/icon_residency_permit_application.svg";
import Icon_residency_permit_documents from "../../static/images/icon_residency_permit_documents.svg";
import Icon_salary_calculator from "../../static/images/icon_salary_calculator.svg";
import Icon_visa_application from "../../static/images/icon_visa_application.svg";
import Icon_visa_checker from "../../static/images/icon_visa_checker.svg";
import Icon_visa_documents from "../../static/images/icon_visa_documents.svg";
import Icon_first_task from "../../static/images/icon_first_task.svg";
import Icon_favorites_empty from "../../static/images/icon_favorites_empty.svg";
import Icon_tasks_empty from "../../static/images/icon_tasks_empty.svg";
import Icon_cases_empty from "../../static/images/icon_cases_empty.svg";
import Icon_income from "../../static/images/icon_income.svg";
import Icon_money from "../../static/images/icon_money.svg";
import Icon_star from "../../static/images/icon_star.svg";
import Icon_whitepaper from "../../static/images/icon_whitepaper.svg";
import Icon_favorite_filled from "../../static/images/material_icon_favorite_filled.svg";
import Icon_partner_exchange from "../../static/images/material_icon_partner_exchange.svg";
import Icon_big_upload_files from "../../static/images/icon_big_upload_files.svg";
import Icon_pdf_sheet from "../../static/images/icon_pdf_sheet.svg";
import Icon_clipboard_time from "../../static/images/icon_clipboard_time.svg";
import Icon_checkmark from "../../static/images/icon_checkmark.svg";
import Icon_trash from "../../static/images/icon_trash.svg";
import Icon_money_up from "../../static/images/icon_money_up.svg";
import Icon_show_profile from "../../static/images/icon_show_profile.svg";
import Icon_more from "../../static/images/icon_more.svg";
import Icon_download_new from "../../static/images/icon_download_new.svg";
import Icon_folder_new from "../../static/images/icon_folder_new.svg";
import Icon_share_new from "../../static/images/icon_share_new.svg";
import Icon_define_state from "../../static/images/icon_define_state.svg";
import Icon_favorite_new from "../../static/images/icon_favorite_new.svg";
import Icon_plus from "../../static/images/icon_plus.svg";
import Icon_applied from "../../static/images/icon_applied.svg";
import Icon_bell from "../../static/images/icon_bell.svg";
import Icon_info_new from "../../static/images/icon_info_new.svg";
import Icon_forbidden from "../../static/images/icon_forbidden.svg";

import Icon_link from "../../static/images/share_icon_link.svg";
import Icon_mail_small from "../../static/images/share_icon_mail_small.svg";

import Icon_groceries from "../../static/images/icon_groceries.svg";
import Icon_healthcare from "../../static/images/icon_healthcare.svg";
import Icon_housing from "../../static/images/icon_housing.svg";
import Icon_transportation from "../../static/images/icon_transportation.svg";

import Icon_project_company from "../../static/images/projects/icon_company.svg";
import Icon_project_date from "../../static/images/projects/icon_date.svg";
import Icon_project_hat from "../../static/images/projects/icon_hat.svg";
import Icon_project_house from "../../static/images/projects/icon_house.svg";
import Icon_project_map from "../../static/images/projects/icon_map.svg";
import Icon_project_money from "../../static/images/projects/icon_money.svg";
import Icon_hint_job_posting from "../../static/images/icon_hint_job_posting.svg";
import Icon_hint_confirm_email from "../../static/images/icon_hint_confirm_email.svg";
import Icon_hint_email_confirmed from "../../static/images/icon_hint_email_confirmed.svg";
import Icon_hint_referral from "../../static/images/icon_hint_referral.svg";
import Icon_hint_sign_up from "../../static/images/icon_hint_sign_up.svg";
import Icon_hint_waiting_list from "../../static/images/icon_hint_waiting_list.svg";
import Icon_hint_warning from "../../static/images/icon_hint_warning.svg";
import Icon_hint_welcome from "../../static/images/icon_hint_welcome.svg";
import Icon_hint_reply_sent from "../../static/images/icon_hint_reply_sent.svg";
import Icon_hint_requests_accepted from "../../static/images/icon_hint_requests_accepted.svg";
import Icon_hint_requests_declined from "../../static/images/icon_hint_requests_declined.svg";
import Icon_stub_company_logo from "../../static/images/stub_logo_work_Experience.svg";

import Icon_arrow_right from "../../static/images/icon_arrow_right.svg";

const ICONS = {
  logo: <Logo />,
  clock: <IconClock />,
  eligibility_checker: <IconEligibilityChecker />,
  residency_permit_checker: <IconResidencyPermitChecker />,
  comparability_procedure: <Icon_comparability_procedure />,
  diplomatic_mission_finder: <Icon_diplomatic_mission_finder />,
  documents: <Icon_documents />,
  early_bird: <Icon_early_bird />,
  find_immigration_office: <Icon_find_immigration_office />,
  health_insurance: <Icon_health_insurance />,
  job_finder: <Icon_job_finder />,
  recognition_procedure: <Icon_recognition_procedure />,
  registration_documents: <Icon_registration_documents />,
  registration_office_finder: <Icon_registration_office_finder />,
  registration: <Icon_registration />,
  regulated_profession_check: <Icon_regulated_profession_check />,
  residency_permit_application: <Icon_residency_permit_application />,
  residency_permit_documents: <Icon_residency_permit_documents />,
  salary_calculator: <Icon_salary_calculator />,
  visa_application: <Icon_visa_application />,
  visa_checker: <Icon_visa_checker />,
  visa_documents: <Icon_visa_documents />,
  first_task: <Icon_first_task />,
  cases_empty: <Icon_cases_empty />,
  filtered_cases_empty: <Icon_tasks_empty />,
  favorites_empty: <Icon_favorites_empty />,
  favorite_new: <Icon_favorite_new />,
  tasks_empty: <Icon_tasks_empty />,
  income: <Icon_income />,
  projects_add: <Icon_projects_add />,
  projects_pending: <Icon_projects_pending />,
  projects_requested: <Icon_projects_requested />,
  star: <Icon_star />,
  money: <Icon_money />,
  whitepaper: <Icon_whitepaper />,
  favorite_filled: <Icon_favorite_filled width="24" height="24" />,
  partner_exchange: <Icon_partner_exchange width="24" height="24" />,
  big_upload_files: <Icon_big_upload_files />,
  pdf_sheet: <Icon_pdf_sheet />,
  checkmark: <Icon_checkmark />,
  trash: <Icon_trash />,
  money_up: <Icon_money_up />,
  show_profile: <Icon_show_profile />,
  more: <Icon_more />,
  download_new: <Icon_download_new />,
  folder_new: <Icon_folder_new />,
  share_new: <Icon_share_new />,
  define_state: <Icon_define_state />,
  plus: <Icon_plus />,
  applied: <Icon_applied />,
  bell: <Icon_bell />,
  info_new: <Icon_info_new />,
  forbidden: <Icon_forbidden />,

  choice_add: <Icon_choice_add />,
  choice_link: <Icon_choice_link />,
  choice_pdf: <Icon_choice_pdf />,

  groceries: <Icon_groceries />,
  healthcare: <Icon_healthcare />,
  housing: <Icon_housing />,
  transportation: <Icon_transportation />,

  handshake_big: <Icon_handshake_big />,
  headset: <Icon_headset />,

  link: <Icon_link />,
  mail_small: <Icon_mail_small />,
  clipboard_time: <Icon_clipboard_time />,

  project_company: <Icon_project_company />,
  project_date: <Icon_project_date />,
  project_hat: <Icon_project_hat />,
  project_house: <Icon_project_house />,
  project_map: <Icon_project_map />,
  project_money: <Icon_project_money />,

  hint_job_posting: <Icon_hint_job_posting />,
  hint_confirm_email: <Icon_hint_confirm_email />,
  hint_email_confirmed: <Icon_hint_email_confirmed />,
  hint_referral: <Icon_hint_referral />,
  hint_sign_up: <Icon_hint_sign_up />,
  hint_waiting_list: <Icon_hint_waiting_list />,
  hint_warning: <Icon_hint_warning />,
  hint_welcome: <Icon_hint_welcome />,
  hint_reply_sent: <Icon_hint_reply_sent />,
  hint_requests_accepted: <Icon_hint_requests_accepted />,
  hint_requests_declined: <Icon_hint_requests_declined />,
  stub_company_logo: <Icon_stub_company_logo />,

  arrow_right: <Icon_arrow_right />,
};

export default function Icon({ children, big, small, ...props }) {
  const classes = classNames(
    "icon material-symbols-rounded",
    big && "icon--big",
    small && "icon--small",
    props.class
  );

  if (ICONS[children]) {
    return (
      <span {...props} class={classes}>
        {ICONS[children]}
      </span>
    );
  }
  return (
    <i {...props} class={classes}>
      {children}
    </i>
  );
}
